<template>
    <div>
        <b-overlay :show="isLoading">
            <spreadify-plugin v-if="table != null"
                @savedFormData="savedData"
                :mapping="table.mapping"
                :config="table.config"
                :data="table.data"
                :isEditable="true" />
        </b-overlay>
    </div>

</template>

<script>
import {getSpreadifyBackend} from '@/helpers/spreadify.js';
export default {
    props:{
        uid:{
            required: true,
        }
    },
    data:() => ({
        table: null,
        isLoading: true,
    }),
    watch:{
        uid(){
            this.loadTable();
        }
    },
    computed:{},
    methods:{
        //* Save event
        savedData(data){
            this.$emit('savedData', data);
        },
        loadTable(){
            this.isLoading = true;
            this.table = null;
            getSpreadifyBackend().getViewConfig(this.uid)
            .then((response) => {
                let config = response;
                config.config_json = JSON.parse(config.config_json);
                let mapping = config.mapping;
                let conf = config.config_json
                let data = []//this.tableData.data;
                this.table = {
                    mapping: mapping,
                    config: conf,
                    data: data,
                }
                this.isLoading = false;
            })
        },
        
    },
    mounted(){
        this.loadTable();
    },
}
</script>

<style>

</style>